import req from "../http";

const jobOpening = {
  // 取得 職缺列表(分頁)
  getJobOpeningPaging(params) {
    return req("get", "/ManpowerDemandModule/Vacancies/paging", params);
  },
};

export default jobOpening;